module.exports = "<div data-component=\"description-tax\">\n\t<div class=\"images\">\n\t\t<img src=\"{{ img }}\" *ngFor=\"let img of images\">\n\t</div>\n\t<p class=\"text\"><strong [innerHTML]=\"description\"></strong></p>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/payment-federal-taxes/description-tax/description-tax.component.html
// module id = ../../../../../src/app/master/payment-federal-taxes/description-tax/description-tax.component.html
// module chunks = main